// NATIVE
import React from 'react';

// INSTALLED
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';

// CUSTOM

/**
 * A functional component that displays a linear progress bar with a label and an optional icon.
 *
 * @param {Object} props - The properties object.
 * @param {number} props.percentage - The percentage value for the progress bar.
 * @param {string} props.label - The label to display alongside the progress bar.
 * @param {boolean} props.hasIcon - A flag indicating whether to display an icon.
 *
 * @returns {JSX.Element} The rendered LinearProgressWithLabel component.
 */
export const LinearProgressWithLabel = (props: any) => {
  //  PROPS
  const { percentage, label, hasIcon } = props;

  // FUNCTION
  function LinearProgressWithLabel(
    props: LinearProgressProps & { percentage: number; label: string; hasIcon: boolean }
  ) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{ width: '100%', flexWrap: 'wrap', mr: 1, wordBreak: 'break-word' }}
          className="eppaa"
        >
          <span>{hasIcon && <PictureAsPdfIcon color="error"></PictureAsPdfIcon>}</span>
          <Typography>{label}</Typography>
          <LinearProgress variant="determinate" value={percentage} color="success" />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2">{`${Math.round(percentage)}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel percentage={percentage} label={label} hasIcon={hasIcon} />
    </Box>
  );
};
